export const BigSearchIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="11" cy="11" r="7" stroke="white" strokeWidth="2" />
    <path
      d="M20 20L16 16"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
